import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/header';
import Footer from '../components/footer';

const EditInvoicePage = () => {
  const { invoiceId } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [bookers, setBookers] = useState([]);
  const navigate = useNavigate();

  // Format Date (default: today)
  const formatDate = (dateStr) => {
    if (!dateStr) {
      return new Date().toISOString().split("T")[0];
    }
    return new Date(dateStr).toISOString().split("T")[0];
  };

  // Format Time (default: current time)
  const formatTime = (timeStr) => {
    if (!timeStr) {
      const now = new Date();
      return now.toTimeString().slice(0, 5);
    }
    return timeStr.slice(0, 5);
  };

  // Fetch invoice
  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const response = await fetch(`https://app.mirzawaleed.com/getInvoiceDetails.php?id=${invoiceId}`);
        const data = await response.json();
        if (data.success) {
          setInvoice({
            ...data.invoice,
            date: formatDate(data.invoice.date),
            time: formatTime(data.invoice.time),
          });
        } else {
          console.error(data.message);
        }
      } catch (error) {
        console.error('Error fetching invoice details:', error);
      }
    };
    fetchInvoice();
  }, [invoiceId]);

  // Fetch bookers
  useEffect(() => {
  const fetchBookers = async () => {
    try {
      const response = await fetch(`https://app.mirzawaleed.com/getBookers.php`);
      const data = await response.json();
      if (Array.isArray(data)) {
        setBookers(data); // direct array set
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error('Error fetching bookers:', error);
    }
  };
  fetchBookers();
}, []);


  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedInvoice = { ...invoice, [name]: value };

    if (name === 'received' || name === 'total') {
      const received = parseFloat(updatedInvoice.received) || 0;
      const total = parseFloat(updatedInvoice.total) || 0;
      updatedInvoice.pending = (total - received).toFixed(2);
    }
    setInvoice(updatedInvoice);
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`https://app.mirzawaleed.com/updateInvoice.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(invoice),
      });
      const data = await response.json();
      if (data.success) {
        navigate(`/invoice/${invoiceId}`);
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error('Error updating invoice:', error);
    }
  };

  return (
    <>
      <Header />
      <div style={{ maxWidth: "600px", margin: "40px auto", padding: "20px", border: "1px solid #ddd", borderRadius: "8px" }}>
        <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Edit Invoice</h1>

        {invoice ? (
          <form onSubmit={handleSubmit}>
            {/* Total */}
            <div style={{ marginBottom: "15px" }}>
              <label>Total</label>
              <input
                type="number"
                name="total"
                value={invoice.total}
                onChange={handleChange}
                required
                style={{ width: "100%", padding: "8px", marginTop: "5px" }}
              />
            </div>

            {/* Pending */}
            <div style={{ marginBottom: "15px" }}>
              <label>Pending</label>
              <input
                type="number"
                name="pending"
                value={invoice.pending}
                readOnly
                style={{ width: "100%", padding: "8px", marginTop: "5px", background: "#f5f5f5" }}
              />
            </div>

            {/* Received */}
            <div style={{ marginBottom: "15px" }}>
              <label>Received</label>
              <input
                type="number"
                name="received"
                value={invoice.received}
                onChange={handleChange}
                required
                style={{ width: "100%", padding: "8px", marginTop: "5px" }}
              />
            </div>

            {/* Booker */}
            <div style={{ marginBottom: "15px" }}>
              <label>Reciver</label>
             <select
              name="reciver"
              value={invoice.booker || ""}
              onChange={handleChange}
              style={{ width: "100%", padding: "8px", marginTop: "5px" }}
            >
              <option value="">Select a Reciver</option>
              {bookers.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>

            </div>

            {/* Date */}
            <div style={{ marginBottom: "15px" }}>
              <label>Date</label>
              <input
                type="date"
                name="date"
                value={invoice.date}
                onChange={handleChange}
                style={{ width: "100%", padding: "8px", marginTop: "5px" }}
              />
            </div>

            {/* Time */}
            <div style={{ marginBottom: "15px" }}>
              <label>Time</label>
              <input
                type="time"
                name="time"
                value={invoice.time}
                onChange={handleChange}
                style={{ width: "100%", padding: "8px", marginTop: "5px" }}
              />
            </div>

            <button type="submit" style={{ width: "100%", padding: "10px", background: "#4b3c7c", color: "#fff", border: "none", borderRadius: "5px" }}>
              Update Invoice
            </button>
          </form>
        ) : (
          <p style={{ textAlign: "center" }}>Loading invoice details...</p>
        )}
      </div>
      <Footer />
    </>
  );
};

export default EditInvoicePage;
